import { leadsLogsListOptions, opportunitiesLogsListOptions } from '@crm/api'
import {
  usePaginationListConfig,
  useQueryUpdate,
  useSessionContext
} from '@shared/hooks'
import { useQuery } from '@tanstack/react-query'
import { Flex, List } from 'antd'
import { ModalProps } from 'antd/lib'

import { KanbanCommentsItem, NoteForm } from '../KanbanCommentsItem'

type KanbanCommentsType = 'opportunity' | 'lead'

type Props = {
  type: KanbanCommentsType
  id?: number
  onCancel: () => void
} & ModalProps

const perPage = 5

export const KanbanComments = ({ type, id, onCancel }: Props) => {
  const { params, updateQuery } = useQueryUpdate()
  const { user } = useSessionContext()

  const { data, isLoading } = useQuery({
    ...opportunitiesLogsListOptions({
      path: { opportunity_id: String(id) },
      query: {
        ...params,
        ...(perPage && { per_page: perPage }),
        type: ['note']
      }
    }),
    enabled: !!id && type === 'opportunity'
  })

  const { data: leadData, isLoading: isLeadLoading } = useQuery({
    ...leadsLogsListOptions({
      path: { lead_id: String(id) },
      query: {
        ...params,
        ...(perPage && { per_page: perPage }),
        type: ['note']
      }
    }),
    enabled: !!id && type === 'lead'
  })

  return (
    <Flex vertical gap={16}>
      <List
        loading={type === 'opportunity' ? isLoading : isLeadLoading}
        dataSource={type === 'opportunity' ? data?.results : leadData?.results}
        pagination={{
          hideOnSinglePage: true,
          ...usePaginationListConfig(data),
          onChange: (page, perPage) =>
            updateQuery({
              ...params,
              page,
              perPage
            })
        }}
        renderItem={(comment) => (
          <KanbanCommentsItem
            key={comment?.id}
            comment={comment}
            isCommentOwner={user?.user?.sso_id === comment?.created_by?.id}
          />
        )}
      />

      <NoteForm type={type} entityId={id} onCancel={onCancel} />
    </Flex>
  )
}
